import React, { useState } from "react";
import "../card/card.scss";
import Dropdown from "../card/DropDown";
import { Checkbox, Dialog, FormLabel } from "@mui/material";
import { Link } from "react-router-dom";
import Button from "../button/Button";
import { CloseIcon, InfoIcon } from "../../icons/svg";
import e from "cors";

const ModalDialog = ({
  open,
  handleClose,
  formTitle,
  to,
  handleChange,
  value,
  isBilat,
}) => {
  const [selectShow, setSelectShow] = useState(false);
  const handleSelectShow = () => {
    setSelectShow((prev) => !prev);
  };

  let singularTitle = formTitle;
  if(formTitle === "Liners") {
    singularTitle = "Liner";
  } 
  if(formTitle === "Feet") {
    singularTitle = "Foot";
  } 

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}     
      >
        <div className="modalHeader">
          <h3 className="h3">{formTitle}</h3>
          <button onClick={handleClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modalContent">
          <p>
            You are going to place a {singularTitle} Order. Please make sure
            information that you are going to input in the form should be
            accurate and precise.
          </p>
          {isBilat && false && //TEMP Disabled
          <div className="BilateralSection">
          <h4>
            If you want to place bilateral order choose the second order form
          </h4>
          <div className="info">
            <InfoIcon />
            <p>
              A bilateral amputation is the surgical removal of more than one
              limb, either both lower extremity or both upper extremity
            </p>
          </div>
          <div className="checkBox">
            <div className="check">
              <Checkbox onChange={handleSelectShow} checked={selectShow} />
              <FormLabel>Bilateral Order </FormLabel>
            </div>
            <p>
              Requires Seperate order forms. Indicate each side on each form
            </p>
            {selectShow && <Dropdown form={value} onChange={handleChange} />}
          </div>
          </div>}
          
        </div>

        <Link to={to} className="link">
          <Button text="Get Started" type="button" />
        </Link>
      </Dialog>
    </div>
  );
};

export default ModalDialog;
